// Basic
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';
// Common
import { getFavicons, getMainFavicon, iphoneDeviceClassname } from '@/common-utils/functions/getFavicons';

// Wrap the application with React-Helmet :
// - update title + favicons
// - add classes to body if the device is considered as "small"
/**
 * @param root0
 * @param root0.domain
 * @param root0.isSmallDevice
 * @param root0.children
 * @param root0.isCustomPay
 * @returns {JSX} WrapWithDomain
 */
function WrapWithDomain({ domain, isSmallDevice, children, isCustomPay }) {

    const mainFavicon = getMainFavicon(domain, isCustomPay);
    const favicon = getFavicons(domain, isCustomPay);
    const iphoneClassname = iphoneDeviceClassname();

    return (
        <HelmetProvider>
            <Helmet bodyAttributes={{ class: isSmallDevice ? `${String(iphoneClassname ?? '')} global-small-device`.trim() : '' }}>
                <title>{String(domain?.title ?? '')}</title>
                {favicon.android384x384 && <link rel='icon' sizes='384x384' href={favicon.android384x384} />}
                {favicon.android192x192 && <link rel='icon' sizes='192x192' href={favicon.android192x192} />}
                {favicon.apple144x144 && <link rel='apple-touch-icon-precomposed' sizes='144x144' href={favicon.apple144x144} />}
                {favicon.apple152x152 && <link rel='apple-touch-icon-precomposed' sizes='152x152' href={favicon.apple152x152} />}
                {favicon.ms144x144 && <meta name='msapplication-TileImage' content={favicon.ms144x144} />}
                {favicon.base32x32 && <link rel='icon' type='image/png' href={favicon.base32x32} sizes='32x32' />}
                {favicon.base16x16 && <link rel='icon' type='image/png' href={favicon.base16x16} sizes='16x16' />}
                <meta name='msapplication-TileColor' content='#FFFFFF' />
                {
                    mainFavicon ?
                        <link rel='shortcut icon' href={mainFavicon} />
                        :
                        false
                }
            </Helmet>
            {children}
        </HelmetProvider>
    );
}

WrapWithDomain.propTypes = {
    isSmallDevice: PropTypes.bool.isRequired,
    domain: PropTypes.object,
    children: PropTypes.element.isRequired,
    isCustomPay: PropTypes.bool
};
export default WrapWithDomain;